module.exports = __webpack_public_path__ + "img/18.3c6218c3.jpg";